import { useState } from 'react';
import { Breadcrumbs, ErrorState } from '../../components';
import useDocumentHead from '../../hooks/useDocumentHead';
import { useLang } from '../../i18n';
import LeadFormModal from '../LeadFormModal';
import { useAboutData } from './hooks/useAboutData';
import HeroSection from './sections/HeroSection';
import MissionSection from './sections/MissionSection';
import ValuesSection from './sections/ValuesSection';
import TimelineSection from './sections/TimelineSection';
import TeamSection from './sections/TeamSection';
import OfficesTeaserSection from './sections/OfficesTeaserSection';
import CtaSection from './sections/CtaSection';
import './AboutPage.scss';

export default function AboutPage() {
  const { t } = useLang();
  const { data, loading, error } = useAboutData();
  const [leadOpen, setLeadOpen] = useState(false);

  useDocumentHead({
    title: `${t('about.title')} — ${t('brand.name')}`,
    description: t('about.hero.lead'),
    canonical: 'https://ukam.uz/about',
    og: {
      title: t('about.hero.title'),
      description: t('about.hero.lead'),
      type: 'website',
      url: 'https://ukam.uz/about',
    },
    schemaOrg: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: t('brand.name'),
        url: 'https://ukam.uz',
        description: t('about.hero.lead'),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        url: 'https://ukam.uz/about',
        name: t('about.title'),
      },
    ],
  });

  if (error && !loading) {
    return (
      <div className="about-page about-page--error">
        <div className="container">
          <Breadcrumbs items={[{ label: t('brand.name'), href: '/' }, { label: t('about.title') }]} />
          <ErrorState title={t('about.empty')} />
        </div>
      </div>
    );
  }

  return (
    <div className="about-page">
      <div className="container about-page__crumbs">
        <Breadcrumbs items={[{ label: t('brand.name'), href: '/' }, { label: t('about.title') }]} />
      </div>
      <HeroSection stats={data.stats} loading={loading} />
      <MissionSection items={data.mission} loading={loading} />
      <ValuesSection values={data.values} loading={loading} />
      <TimelineSection milestones={data.milestones} loading={loading} />
      <TeamSection team={data.team} loading={loading} />
      <OfficesTeaserSection offices={data.offices} loading={loading} />
      <CtaSection onOpenLead={() => setLeadOpen(true)} />
      <LeadFormModal open={leadOpen} onClose={() => setLeadOpen(false)} />
    </div>
  );
}
